var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"content-wrapper"},[_c('app-page-top-section',{attrs:{"title":_vm.$t('import_/_export')}}),_vm._v(" "),_c('app-custom-tab',{attrs:{"tabs":_vm.tabs,"icon":"settings"}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }